import * as z from "zod";

export const updateSelfServeOnboardingDealSize = {
  name: "updateSelfServeOnboardingDealSize" as const,
  input: z.object({
    merchantId: z.string(),
    dealSize: z.number().nullable(),
    product: z.enum(["returns", "order-editing"]).default("returns"),
  }),
  output: z.object({ success: z.boolean() }),
};

export type UpdateSelfServeOnboardingDealSizeInput = z.infer<
  typeof updateSelfServeOnboardingDealSize.input
>;
export type UpdateSelfServeOnboardingDealSizeOutput = z.infer<
  typeof updateSelfServeOnboardingDealSize.output
>;
